import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Users, CalendarCheck, Mail, TrendingUp } from "lucide-react";

export default function AdminDashboard() {
    const [stats, setStats] = useState(null);
    useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)); }, []);
    const items = [
        { l: "New Leads", v: stats?.new_leads ?? "—", icon: TrendingUp, color: "#E8B923" },
        { l: "Total Leads", v: stats?.leads ?? "—", icon: Users, color: "#2563EB" },
        { l: "Demo Requests", v: stats?.demo_requests ?? "—", icon: CalendarCheck, color: "#10B981" },
        { l: "Contact Enquiries", v: stats?.contacts ?? "—", icon: Mail, color: "#8B5CF6" },
    ];
    return (
        <div data-testid="admin-dashboard">
            <div className="eyebrow eyebrow--slate">Dashboard</div>
            <h1 className="font-serif text-4xl text-navy mt-3">Operations Overview</h1>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4 mt-10">
                {items.map((s) => (
                    <div key={s.l} className="bg-white border border-slate-200 rounded-xl p-6">
                        <div className="flex items-center justify-between">
                            <div className="text-xs font-mono uppercase tracking-widest text-slate-500">{s.l}</div>
                            <s.icon className="w-4 h-4" style={{ color: s.color }} />
                        </div>
                        <div className="font-serif text-4xl text-navy mt-4">{s.v}</div>
                    </div>
                ))}
            </div>
        </div>
    );
}
